export default "__VITE_ASSET__DgnYg_dW__"